/**
 * 平台差异全部收口在这里：
 *   - role：brand（广告主）
 *   - platform：运行时判断 pc / h5
 *   - ModalShell：统一常驻 fixed shell（桌面全屏；与达人端共用组件实现）
 *
 * App.tsx 只需 <TimModal />，对平台细节零感知。
 */
import React from 'react';
import { isMobile } from '@/biz/tool';
import { CloseIcon } from '@/components/icons';
import Tracker from '@/utils/track';
import TimModal from './TimModal';
import ModalShell from './ModalShell';
import type { TimOpenSource } from './useTimModalStore';

const BrandTimModal: React.FC = () => {
  const handleTrackFirstOpen = React.useCallback(
    ({
      source,
      role,
      platform
    }: {
      source: TimOpenSource;
      role: 'brand' | 'creator';
      platform: 'pc' | 'h5';
    }) => {
      Tracker.gtag('event', 'screen_view', {
        event_category: 'tim_panel_first_open',
        tim_open_source: source,
        role,
        platform
      });
    },
    []
  );

  return (
    <TimModal
      role="brand"
      platform="pc"
      ModalShell={ModalShell}
      closeIcon={<CloseIcon className="w-[16px] h-[16px]" />}
      trackFirstOpen={handleTrackFirstOpen}
    />
  );
};

export default BrandTimModal;
